import React, { useEffect, lazy, Suspense } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider, useCart } from "./context/CartContext";
import Header from "./components/Header";
import Footer from "./components/Footer";
import MobileBottomNav from "./components/MobileBottomNav";
import PageLoader from "./components/PageLoader";
import InstallAppPrompt from "./components/InstallAppPrompt";
import Home from "./pages/Home";
import Catalog from "./pages/Catalog";
import ProductDetail from "./pages/ProductDetail";
import Cart from "./pages/Cart";
const Checkout = lazy(() => import("./pages/Checkout"));
const OrderConfirmation = lazy(() => import("./pages/OrderConfirmation"));
const Wishlist = lazy(() => import("./pages/Wishlist"));
const BabyProducts = lazy(() => import("./pages/BabyProducts"));
const BabyGuide = lazy(() => import("./pages/BabyGuide"));
const BabyRegistryManage = lazy(() => import("./pages/BabyRegistryManage"));
const BabyRegistryPublic = lazy(() => import("./pages/BabyRegistryPublic"));
const RegistryThanks = lazy(() => import("./pages/RegistryThanks"));
const Account = lazy(() => import("./pages/Account"));
const Rca = lazy(() => import("./pages/Rca"));
const RcaQuote = lazy(() => import("./pages/RcaQuote"));
const RcaPaymentReturn = lazy(() => import("./pages/RcaPaymentReturn"));
const InsuranceProducts = lazy(() => import("./pages/admin/InsuranceProducts"));
const Orders = lazy(() => import("./pages/Orders"));
const Login = lazy(() => import("./pages/Login"));
const AuthCallback = lazy(() => import("./pages/AuthCallback"));
const CompleteProfile = lazy(() => import("./pages/CompleteProfile"));
const Register = lazy(() => import("./pages/Register"));
const ForgotPassword = lazy(() => import("./pages/ForgotPassword"));
const ResetPassword = lazy(() => import("./pages/ResetPassword"));
const AdminLayout = lazy(() => import("./pages/admin/AdminLayout"));
const AdminLogin = lazy(() => import("./pages/admin/AdminLogin"));
const AdminDashboard = lazy(() => import("./pages/admin/Dashboard"));
const AdminProducts = lazy(() => import("./pages/admin/Products"));
const CategoriesHub = lazy(() => import("./pages/admin/categories/CategoriesHub"));
const ChatBuy = lazy(() => import("./pages/admin/ChatBuy"));
const AdminOrders = lazy(() => import("./pages/admin/Orders"));
const AdminPayments = lazy(() => import("./pages/admin/Payments"));
const SyncAlerts = lazy(() => import("./pages/admin/SyncAlerts"));
const Users = lazy(() => import("./pages/admin/Users"));
const Reviews = lazy(() => import("./pages/admin/Reviews"));
const Backup = lazy(() => import("./pages/admin/Backup"));
const Coupons = lazy(() => import("./pages/admin/Coupons"));
const Banners = lazy(() => import("./pages/admin/Banners"));
const Marketing = lazy(() => import("./pages/admin/Marketing"));
const FanCourierSettings = lazy(() => import("./pages/admin/FanCourierSettings"));
const EmailSettings = lazy(() => import("./pages/admin/EmailSettings"));
const SamedaySettings = lazy(() => import("./pages/admin/SamedaySettings"));
const Analytics = lazy(() => import("./pages/admin/Analytics"));
const Suppliers = lazy(() => import("./pages/admin/Suppliers"));
const SupplierTemplate = lazy(() => import("./pages/admin/SupplierTemplate"));
const SupplierIntegration = lazy(() => import("./pages/admin/SupplierIntegration"));
const Integrations = lazy(() => import("./pages/admin/Integrations"));
const EmagIntegration = lazy(() => import("./pages/admin/EmagIntegration"));
const OkaziiIntegration = lazy(() => import("./pages/admin/OkaziiIntegration"));
const OlxIntegration = lazy(() => import("./pages/admin/OlxIntegration"));
const SupplierSamedayIntegration = lazy(() => import("./pages/admin/SupplierSamedayIntegration"));
const SupplierFanCourierIntegration = lazy(() => import("./pages/admin/SupplierFanCourierIntegration"));
const CargusIntegration = lazy(() => import("./pages/admin/CargusIntegration"));
const UpsIntegration = lazy(() => import("./pages/admin/UpsIntegration"));
const DpdIntegration = lazy(() => import("./pages/admin/DpdIntegration"));
const GlsIntegration = lazy(() => import("./pages/admin/GlsIntegration"));
const ColeteOnlineIntegration = lazy(() => import("./pages/admin/ColeteOnlineIntegration"));
const DhlIntegration = lazy(() => import("./pages/admin/DhlIntegration"));
const CasaPescaIntegration = lazy(() => import("./pages/admin/CasaPescaIntegration"));
const BtsIntegration = lazy(() => import("./pages/admin/BtsIntegration"));
const Sun7Integration = lazy(() => import("./pages/admin/Sun7Integration"));
const GriffatiIntegration = lazy(() => import("./pages/admin/GriffatiIntegration"));
const SymphonyaIntegration = lazy(() => import("./pages/admin/SymphonyaIntegration"));
const FxRates = lazy(() => import("./pages/admin/FxRates"));
const SupplierPurge = lazy(() => import("./pages/admin/SupplierPurge"));
const AtlasIntegration = lazy(() => import("./pages/admin/AtlasIntegration"));
const SafetyBrokerIntegration = lazy(() => import("./pages/admin/SafetyBrokerIntegration"));
const PacketaIntegration = lazy(() => import("./pages/admin/PacketaIntegration"));
const SmartbillIntegration = lazy(() => import("./pages/admin/SmartbillIntegration"));
const OblioIntegration = lazy(() => import("./pages/admin/OblioIntegration"));
const FgoIntegration = lazy(() => import("./pages/admin/FgoIntegration"));
const OscommerceIntegration = lazy(() => import("./pages/admin/OscommerceIntegration"));
const StagingProducts = lazy(() => import("./pages/admin/StagingProducts"));
const PrestashopIntegration = lazy(() => import("./pages/admin/PrestashopIntegration"));
const ShopifyIntegration = lazy(() => import("./pages/admin/ShopifyIntegration"));
const OpencartIntegration = lazy(() => import("./pages/admin/OpencartIntegration"));
const MerchantproIntegration = lazy(() => import("./pages/admin/MerchantproIntegration"));
const TrendyolIntegration = lazy(() => import("./pages/admin/TrendyolIntegration"));
const WoocommerceIntegration = lazy(() => import("./pages/admin/WoocommerceIntegration"));
const CartumIntegration = lazy(() => import("./pages/admin/CartumIntegration"));
const GomagIntegration = lazy(() => import("./pages/admin/GomagIntegration"));
const CompariIntegration = lazy(() => import("./pages/admin/CompariIntegration"));
const NetopiaIntegration = lazy(() => import("./pages/admin/NetopiaIntegration"));
const MerchantCenterIntegration = lazy(() => import("./pages/admin/MerchantCenterIntegration"));
const GoogleMerchant = lazy(() => import("./pages/admin/GoogleMerchant"));
const StripeIntegration = lazy(() => import("./pages/admin/StripeIntegration"));
const EuplatescIntegration = lazy(() => import("./pages/admin/EuplatescIntegration"));
const PayuIntegration = lazy(() => import("./pages/admin/PayuIntegration"));
const PlationlineIntegration = lazy(() => import("./pages/admin/PlationlineIntegration"));
const EmagAwbIntegration = lazy(() => import("./pages/admin/EmagAwbIntegration"));
const ClicksendIntegration = lazy(() => import("./pages/admin/ClicksendIntegration"));
const BulkgateIntegration = lazy(() => import("./pages/admin/BulkgateIntegration"));
const GosmsIntegration = lazy(() => import("./pages/admin/GosmsIntegration"));
const VatSettings = lazy(() => import("./pages/admin/VatSettings"));
const AdminSettings = lazy(() => import("./pages/admin/Settings"));
const BackupManager = lazy(() => import("./pages/admin/BackupManager"));
const EmailVerified = lazy(() => import("./pages/EmailVerified"));
import { Toaster } from "./components/ui/toaster";
import AdminQuickMove from "./components/AdminQuickMove";

// Facturare imports
const FacturareDashboard = lazy(() => import("./pages/Dashboard"));
const FacturaCompanies = lazy(() => import("./pages/FacturaCompanies"));
const Clients = lazy(() => import("./pages/Clients"));
const FacturareProducts = lazy(() => import("./pages/Products"));
const Invoices = lazy(() => import("./pages/Invoices"));
const InvoiceForm = lazy(() => import("./pages/InvoiceForm"));
const InvoiceView = lazy(() => import("./pages/InvoiceView"));

// User account imports
const Addresses = lazy(() => import("./pages/Addresses"));
const UserCompanies = lazy(() => import("./pages/UserCompanies"));
const PickupPoints = lazy(() => import("./pages/PickupPoints"));
const Reports = lazy(() => import("./pages/Reports"));
const Settings = lazy(() => import("./pages/Settings"));

// Supplier Portal imports
const SupplierLogin = lazy(() => import("./pages/supplier/SupplierLogin"));
const SupplierLayout = lazy(() => import("./pages/supplier/SupplierLayout"));
const SupplierDashboard = lazy(() => import("./pages/supplier/SupplierDashboard"));
const SupplierProducts = lazy(() => import("./pages/supplier/SupplierProducts"));
const SupplierOrders = lazy(() => import("./pages/supplier/SupplierOrders"));
const SupplierOscommerce = lazy(() => import("./pages/supplier/SupplierOscommerce"));
const SupplierTrendyol = lazy(() => import("./pages/supplier/SupplierTrendyol"));
const SupplierImportSync = lazy(() => import("./pages/supplier/SupplierImportSync"));
const SupplierAtlasFeed = lazy(() => import("./pages/supplier/SupplierAtlasFeed"));
const SupplierRoyalFeed = lazy(() => import("./pages/supplier/SupplierRoyalFeed"));
const SupplierAsbisFeed = lazy(() => import("./pages/supplier/SupplierAsbisFeed"));
const SupplierOfficeGalaxyFeed = lazy(() => import("./pages/supplier/SupplierOfficeGalaxyFeed"));
const SupplierDacrisFeed = lazy(() => import("./pages/supplier/SupplierDacrisFeed"));
const SupplierEtoolsFeed = lazy(() => import("./pages/supplier/SupplierEtoolsFeed"));
const SupplierApertaFeed = lazy(() => import("./pages/supplier/SupplierApertaFeed"));
const SupplierRtcFeed = lazy(() => import("./pages/supplier/SupplierRtcFeed"));
const SupplierAdaconiFeed = lazy(() => import("./pages/supplier/SupplierAdaconiFeed"));
const SupplierBtsFeed = lazy(() => import("./pages/supplier/SupplierBtsFeed"));
const SupplierBabyproductsFeed = lazy(() => import("./pages/supplier/SupplierBabyproductsFeed"));
const SupplierSun7Feed = lazy(() => import("./pages/supplier/SupplierSun7Feed"));
const SupplierGriffatiFeed = lazy(() => import("./pages/supplier/SupplierGriffatiFeed"));
const SupplierSymphonyaFeed = lazy(() => import("./pages/supplier/SupplierSymphonyaFeed"));
const SupplierSpyShopFeed = lazy(() => import("./pages/supplier/SupplierSpyShopFeed"));
const SupplierNodFeed = lazy(() => import("./pages/supplier/SupplierNodFeed"));
const SupplierMobileSentrixFeed = lazy(() => import("./pages/supplier/SupplierMobileSentrixFeed"));
const SupplierArcoexpertFeed = lazy(() => import("./pages/supplier/SupplierArcoexpertFeed"));
const SupplierSettings = lazy(() => import("./pages/supplier/SupplierSettings"));

// Legal pages imports
const Contact = lazy(() => import("./pages/legal/Contact"));
const ReturnForm = lazy(() => import("./pages/legal/ReturnForm"));
const ProductRecalls = lazy(() => import("./pages/legal/ProductRecalls"));
const PostalServices = lazy(() => import("./pages/legal/PostalServices"));
const ANPC = lazy(() => import("./pages/legal/ANPC"));
const PrivacyPolicy = lazy(() => import("./pages/legal/PrivacyPolicy"));
const CookiesPolicy = lazy(() => import("./pages/legal/CookiesPolicy"));
const ReturnPolicy = lazy(() => import("./pages/legal/ReturnPolicy"));
const Shipping = lazy(() => import("./pages/legal/Shipping"));
const Warranty = lazy(() => import("./pages/legal/Warranty"));
const About = lazy(() => import("./pages/legal/About"));
const FAQ = lazy(() => import("./pages/legal/FAQ"));
const SAL = lazy(() => import("./pages/legal/SAL"));
const Terms = lazy(() => import("./pages/legal/Terms"));
const IpayIntegration = lazy(() => import("./pages/admin/IpayIntegration"));
const PaymentResult = lazy(() => import("./pages/PaymentResult"));

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

// Inner component to access CartContext
function AppRoutes() {
  const { cartCount, wishlistCount } = useCart();
  const location = useLocation();

  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  // Verificăm sincron fragmentul #session_id= înainte de orice rută protejată
  if (location.hash?.includes('session_id=')) {
    return (
      <Suspense fallback={<PageLoader />}>
        <AuthCallback />
      </Suspense>
    );
  }

  return (
    <>
      <ScrollToTop />
      <Suspense fallback={<PageLoader />}>
      <Routes>
        {/* Google sign-in callback */}
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/finalizare-cont" element={<CompleteProfile />} />

        {/* Admin login - separate from regular login */}
        <Route path="/admin/login" element={<AdminLogin />} />
        
        {/* Admin routes */}
        <Route path="/admin" element={<AdminLayout />}>
          <Route index element={<AdminDashboard />} />
          <Route path="products" element={<AdminProducts />} />
          <Route path="categories" element={<CategoriesHub />} />
          <Route path="category-manager" element={<Navigate to="/admin/categories" replace />} />
          <Route path="ai-categories" element={<Navigate to="/admin/categories" replace />} />
          <Route path="chat-buy" element={<ChatBuy />} />
          <Route path="coupons" element={<Coupons />} />
          <Route path="banners" element={<Banners />} />
          <Route path="marketing" element={<Marketing />} />
          <Route path="orders" element={<AdminOrders />} />
          <Route path="payments" element={<AdminPayments />} />
          <Route path="alerts" element={<SyncAlerts />} />
          <Route path="users" element={<Users />} />
          <Route path="reviews" element={<Reviews />} />
          <Route path="backup" element={<Backup />} />
          <Route path="analytics" element={<Analytics />} />
          <Route path="integrations" element={<Integrations />} />
          <Route path="fx" element={<FxRates />} />
          <Route path="google-merchant" element={<GoogleMerchant />} />
          <Route path="payments/ipay" element={<IpayIntegration />} />
          <Route path="suppliers/:supplierId/integrations/emag" element={<EmagIntegration />} />
          <Route path="suppliers/:supplierId/integrations/okazii" element={<OkaziiIntegration />} />
          <Route path="suppliers/:supplierId/integrations/olx" element={<OlxIntegration />} />
          <Route path="suppliers/:supplierId/integrations/sameday" element={<SupplierSamedayIntegration />} />
          <Route path="suppliers/:supplierId/integrations/fancourier" element={<SupplierFanCourierIntegration />} />
          <Route path="suppliers/:supplierId/integrations/cargus" element={<CargusIntegration />} />
          <Route path="suppliers/:supplierId/integrations/ups" element={<UpsIntegration />} />
          <Route path="suppliers/:supplierId/integrations/dpd" element={<DpdIntegration />} />
          <Route path="suppliers/:supplierId/integrations/gls" element={<GlsIntegration />} />
          <Route path="suppliers/:supplierId/integrations/dhl" element={<DhlIntegration />} />
          <Route path="suppliers/:supplierId/integrations/coleteonline" element={<ColeteOnlineIntegration />} />
          <Route path="suppliers/:supplierId/integrations/casa-pesca" element={<CasaPescaIntegration />} />
          <Route path="suppliers/:supplierId/integrations/bts" element={<BtsIntegration />} />
          <Route path="suppliers/:supplierId/integrations/7sun" element={<Sun7Integration />} />
          <Route path="suppliers/:supplierId/integrations/griffati" element={<GriffatiIntegration />} />
          <Route path="suppliers/:supplierId/integrations/symphonya" element={<SymphonyaIntegration />} />
          <Route path="suppliers/:supplierId/integrations/safety-broker" element={<SafetyBrokerIntegration />} />
          <Route path="suppliers/:supplierId/purge" element={<SupplierPurge />} />
          <Route path="suppliers/:supplierId/integrations/atlas" element={<AtlasIntegration />} />
          <Route path="suppliers/:supplierId/integrations/packeta" element={<PacketaIntegration />} />
          <Route path="suppliers/:supplierId/integrations/smartbill" element={<SmartbillIntegration />} />
          <Route path="suppliers/:supplierId/integrations/oblio" element={<OblioIntegration />} />
          <Route path="suppliers/:supplierId/integrations/fgo" element={<FgoIntegration />} />
          <Route path="suppliers/:supplierId/integrations/oscommerce" element={<OscommerceIntegration />} />
          <Route path="suppliers/:supplierId/integrations/prestashop" element={<PrestashopIntegration />} />
          <Route path="suppliers/:supplierId/integrations/shopify" element={<ShopifyIntegration />} />
          <Route path="suppliers/:supplierId/integrations/opencart" element={<OpencartIntegration />} />
          <Route path="suppliers/:supplierId/integrations/merchantpro" element={<MerchantproIntegration />} />
          <Route path="suppliers/:supplierId/integrations/trendyol" element={<TrendyolIntegration />} />
          <Route path="suppliers/:supplierId/integrations/woocommerce" element={<WoocommerceIntegration />} />
          <Route path="suppliers/:supplierId/integrations/cartum" element={<CartumIntegration />} />
          <Route path="suppliers/:supplierId/integrations/gomag" element={<GomagIntegration />} />
          <Route path="suppliers/:supplierId/integrations/compari" element={<CompariIntegration />} />
          <Route path="suppliers/:supplierId/integrations/merchantcenter" element={<MerchantCenterIntegration />} />
          <Route path="suppliers/:supplierId/integrations/netopia" element={<NetopiaIntegration />} />
          <Route path="suppliers/:supplierId/integrations/stripe" element={<StripeIntegration />} />
          <Route path="suppliers/:supplierId/integrations/euplatesc" element={<EuplatescIntegration />} />
          <Route path="suppliers/:supplierId/integrations/payu" element={<PayuIntegration />} />
          <Route path="suppliers/:supplierId/integrations/plationline" element={<PlationlineIntegration />} />
          <Route path="suppliers/:supplierId/integrations/emagawb" element={<EmagAwbIntegration />} />
          <Route path="suppliers/:supplierId/integrations/clicksend" element={<ClicksendIntegration />} />
          <Route path="suppliers/:supplierId/integrations/bulkgate" element={<BulkgateIntegration />} />
          <Route path="suppliers/:supplierId/integrations/gosms" element={<GosmsIntegration />} />
          <Route path="fan-courier" element={<FanCourierSettings />} />
          <Route path="sameday" element={<SamedaySettings />} />
          <Route path="email" element={<EmailSettings />} />
          <Route path="insurance" element={<InsuranceProducts />} />
          <Route path="suppliers" element={<Suppliers />} />
          <Route path="suppliers/:supplierId/template" element={<SupplierTemplate />} />
          <Route path="suppliers/:supplierId/integration" element={<SupplierIntegration />} />
          <Route path="suppliers/:supplierId/staging" element={<StagingProducts />} />
          <Route path="vat" element={<VatSettings />} />
          <Route path="settings" element={<AdminSettings />} />
          <Route path="backups" element={<BackupManager />} />
        </Route>

        {/* Email verification success page */}
        <Route path="/email-verified" element={<EmailVerified />} />

        {/* Facturare routes - standalone without header/footer */}
        <Route path="/factura" element={<FacturareDashboard />} />
        <Route path="/factura/dashboard" element={<FacturareDashboard />} />
        <Route path="/factura/companies" element={<FacturaCompanies />} />
        <Route path="/factura/clients" element={<Clients />} />
        <Route path="/factura/products" element={<FacturareProducts />} />
        <Route path="/factura/invoices" element={<Invoices />} />
        <Route path="/factura/invoices/new" element={<InvoiceForm />} />
        <Route path="/factura/invoices/:id" element={<InvoiceView />} />
        <Route path="/factura/reports" element={<Reports />} />
        <Route path="/factura/settings" element={<Settings />} />
        
        {/* Supplier Portal Routes - with unique supplier slug in all URLs */}
        <Route path="/supplier/login/:supplierSlug" element={<SupplierLogin />} />
        <Route path="/supplier/:supplierSlug" element={<SupplierLayout />}>
          <Route index element={<SupplierDashboard />} />
          <Route path="dashboard" element={<SupplierDashboard />} />
          <Route path="products" element={<SupplierProducts />} />
          <Route path="orders" element={<SupplierOrders />} />
          <Route path="oscommerce" element={<SupplierOscommerce />} />
          <Route path="trendyol" element={<SupplierTrendyol />} />
          <Route path="import-sync" element={<SupplierImportSync />} />
          <Route path="atlas-feed" element={<SupplierAtlasFeed />} />
          <Route path="royal-feed" element={<SupplierRoyalFeed />} />
          <Route path="asbis-feed" element={<SupplierAsbisFeed />} />
          <Route path="officegalaxy-feed" element={<SupplierOfficeGalaxyFeed />} />
          <Route path="dacris-feed" element={<SupplierDacrisFeed />} />
          <Route path="etools-feed" element={<SupplierEtoolsFeed />} />
          <Route path="aperta-feed" element={<SupplierApertaFeed />} />
          <Route path="rtc-feed" element={<SupplierRtcFeed />} />
          <Route path="adaconi-feed" element={<SupplierAdaconiFeed />} />
          <Route path="bts-feed" element={<SupplierBtsFeed />} />
          <Route path="babyproducts-feed" element={<SupplierBabyproductsFeed />} />
          <Route path="7sun-feed" element={<SupplierSun7Feed />} />
          <Route path="griffati-feed" element={<SupplierGriffatiFeed />} />
          <Route path="symphonya-feed" element={<SupplierSymphonyaFeed />} />
          <Route path="spyshop-feed" element={<SupplierSpyShopFeed />} />
          <Route path="nod-feed" element={<SupplierNodFeed />} />
          <Route path="sentrix-feed" element={<SupplierMobileSentrixFeed />} />
          <Route path="arcoexpert-feed" element={<SupplierArcoexpertFeed />} />
          <Route path="settings" element={<SupplierSettings />} />
        </Route>
        {/* Legacy routes - redirect to new format */}
        <Route path="/supplier/dashboard" element={<SupplierLayout />} />
        <Route path="/supplier/products" element={<SupplierLayout />} />
        <Route path="/supplier/orders" element={<SupplierLayout />} />

        {/* Main routes with header/footer - wrapped - MUST BE LAST */}
        <Route path="/*" element={
          <>
            <Header cartCount={cartCount} wishlistCount={wishlistCount} />
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/catalog" element={<Catalog />} />
              <Route path="/product/:id" element={<ProductDetail />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/order-confirmation" element={<OrderConfirmation />} />
              <Route path="/wishlist" element={<Wishlist />} />
              <Route path="/account" element={<Account />} />
              <Route path="/rca" element={<Rca />} />
              <Route path="/rca/moto" element={<Rca />} />
              <Route path="/bebelusi" element={<BabyProducts />} />
              <Route path="/bebelusi/ghid" element={<BabyGuide />} />
              <Route path="/lista-nasterii" element={<BabyRegistryManage />} />
              <Route path="/lista-nasterii/multumeste/:purchaseId" element={<RegistryThanks />} />
              <Route path="/lista-nasterii/:token" element={<BabyRegistryPublic />} />
              <Route path="/rca/ofertare/:vehicleId" element={<RcaQuote />} />
              <Route path="/rca/plata-retur" element={<RcaPaymentReturn />} />
              <Route path="/addresses" element={<Addresses />} />
              <Route path="/companies" element={<UserCompanies />} />
              <Route path="/pickup-points" element={<PickupPoints />} />
              <Route path="/orders" element={<Orders />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password/:token" element={<ResetPassword />} />
              
              {/* Legal pages */}
              <Route path="/contact" element={<Contact />} />
              <Route path="/formular-retur" element={<ReturnForm />} />
              <Route path="/rechemare-produse" element={<ProductRecalls />} />
              <Route path="/servicii-postale" element={<PostalServices />} />
              <Route path="/anpc" element={<ANPC />} />
              <Route path="/anpc-sal" element={<SAL />} />
              <Route path="/termeni" element={<Terms />} />
              <Route path="/gdpr" element={<PrivacyPolicy />} />
              <Route path="/cookies" element={<CookiesPolicy />} />
              <Route path="/politica-retur" element={<ReturnPolicy />} />
              <Route path="/livrare" element={<Shipping />} />
              <Route path="/garantie" element={<Warranty />} />
              <Route path="/despre" element={<About />} />
              <Route path="/faq" element={<FAQ />} />
              <Route path="/payment-result" element={<PaymentResult />} />
            </Routes>
            <Footer />
            <MobileBottomNav cartCount={cartCount} />
          </>
        } />
      </Routes>
      </Suspense>
      <InstallAppPrompt />
      <AdminQuickMove />
      <Toaster />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <AppRoutes />
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
// Build timestamp: 1764520766
